import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { PublicCta } from '../../features/public/PublicCta';
import { seoForPath } from '../../features/public/seoConfig';

const BENEFITS = [
  {
    title: 'Organize rides for your club or crew',
    body: 'Create rides with routes, meeting points, and captain roles so your group stays coordinated from start to finish.',
  },
  {
    title: 'Invite riders with links and QR codes',
    body: 'Share a join link or QR code so members can RSVP without hunting through group chats.',
  },
  {
    title: 'Manage roles and participation',
    body: 'See who has joined, assign captains, and keep ride details visible only to invited participants.',
  },
  {
    title: 'Grow your riding community',
    body: 'Give your motorcycle club a dedicated home for upcoming rides, member coordination, and group history.',
  },
] as const;

export function ForRidingGroupsPage() {
  return (
    <PublicContentPage seo={seoForPath('/for-riding-groups')}>
      {publicPageHeading(
        'A motorcycle club app for riding groups',
        'Tools built for group ride captains, club admins, and riding communities who need more than a WhatsApp group to organize motorcycle rides.',
      )}
      <section aria-labelledby="group-benefits">
        <h2 id="group-benefits" className="sr-only">
          Benefits for riding groups and clubs
        </h2>
        <ul className="space-y-4">
          {BENEFITS.map(({ title, body }) => (
            <li
              key={title}
              className="rounded-2xl bg-surface p-5 shadow-sm shadow-black/[0.04] dark:shadow-black/20"
            >
              <h2 className="text-base font-semibold">{title}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">{body}</p>
            </li>
          ))}
        </ul>
      </section>
      <section className="mt-10 space-y-3" aria-labelledby="group-who">
        <h2 id="group-who" className="text-lg font-semibold">
          Built for clubs, crews, and touring groups
        </h2>
        <p className="text-sm leading-relaxed text-muted sm:text-base">
          Whether you run a formal motorcycle club or an informal weekend riding group, RideMaadi
          helps you organize rides, invite members, and keep every group adventure on track.
        </p>
      </section>
      <div className="mt-12">
        <PublicCta heading="Organize your next club ride on RideMaadi" />
      </div>
    </PublicContentPage>
  );
}
